import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, FormGroup, Modal, ModalBody, Row, Spinner } from "reactstrap";
import { loginAction } from "../../actions/general";
import illustration from "../../resources/SVG/IMG_680x324px_Ilustration.svg";
import TwoFactorAuth from "../TwoFactorAuth/TwoFactorAuth";
import "../Login/login.css";

const ManageLogin = ({ loginAction, isFetching }) => {
  const { register, handleSubmit } = useForm();
  const history = useHistory();

  useEffect(() => {
    // If already authenticated (token present) and no pending two-factor, redirect to home
    const token = sessionStorage.getItem("tokenAuthLFS");
    const twoFactor = sessionStorage.getItem("twoFactor");
    if (token && !twoFactor) {
      // replace so the user doesn't stay in history on /manage
      history.replace("/");
    }
  }, [history]);

  const form = (
    <form
      className="card-left"
      onSubmit={handleSubmit((values) => {
        // After successful management login, redirect to home (/) and let app decide
        loginAction(values.username, values.password, history, "/");
      })}
    >
      <Row className="mr-0" style={{ marginTop: "15%" }}>
        <FormGroup className="col-12 login-input-container">
          <input
            type="text"
            className="login-input"
            placeholder="Username"
            name="username"
            required
            ref={register}
          />
        </FormGroup>

        <FormGroup className="col-12 login-input-container">
          <input
            type="password"
            className="login-input"
            placeholder="Password"
            name="password"
            required
            ref={register}
          />
        </FormGroup>

        <div className="login__buttons">
          <Button className="login-button" color="primary" size="lg" disabled={isFetching}>
            {isFetching ? (
              <>
                <Spinner size="sm">Loading...</Spinner>
                <span> Loading</span>
              </>
            ) : (
              "Login"
            )}
          </Button>
        </div>
      </Row>
    </form>
  );

  return (
    <Modal
      isOpen={
        !(
          sessionStorage.getItem("usernameLFS") &&
          sessionStorage.getItem("tokenAuthLFS")
        ) ||
        sessionStorage.getItem("twoFactor")
      }
      className="my-login"
      fade={false}
    >
      <ModalBody>
        <Row style={{ marginLeft: "-16px" }}>
          <div className="hidden-xs col-sm-6 col-md-8">
            <div className="hidden-xs big-background-img overflow-auto">
              <h3 className="welcome card-left pt-5">Welcome to</h3>
              <h1 className="title card-left">
                Legal & Field Staff Management<br />
              </h1>

              <div className="illustration-container card-left">
                <img
                  src={illustration}
                  alt="login illustration"
                  className="illustration"
                />
              </div>
            </div>
          </div>

          {sessionStorage.getItem("usernameLFS") &&
            sessionStorage.getItem("tokenAuthLFS") &&
            sessionStorage.getItem("twoFactor") && (
              <div className="col-12 col-sm-6 col-md-4 pl-0 overflow-auto">
                <div className="from-container">
                  <TwoFactorAuth />
                </div>
              </div>
            )}

          {!(
            sessionStorage.getItem("usernameLFS") &&
            sessionStorage.getItem("tokenAuthLFS")
          ) && (
            <div className="col-12 col-sm-6 col-md-4 pl-0">
              <div className="from-container">{form}</div>
            </div>
          )}
        </Row>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = ({ isFetching }) => ({
  isFetching,
});

const mapDispatchProps = (dispatch) => {
  return {
    loginAction,
  };
};

export default connect(mapStateToProps, mapDispatchProps)(ManageLogin);